import React, { ReactElement } from 'react'
import { link, paper } from '../assets/images/images'

const PdfLink = ({
  to,
  title,
  className,
}: {
  to: string
  title: string
  className?: string
}): ReactElement => {
  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      className={`py2 mb15 borderYDefault linkDefault fontSizeDefault fontWeightBold  dFlex alignItemsCenter justifyContentBetween ${className}`}
      data-testid="pdfLink"
    >
      <div className="dFlex alignItemsCenter">
        <img src={paper} alt="paper-img" className="mr2" />
        {title}
      </div>
      <img src={link} alt="link-img" className="mw3" />
    </a>
  )
}

export default PdfLink
